import React from "react";
import { motion } from "framer-motion";
import { whyChooseData } from "../Data";

const WhyChoose = ({
  image,
  desc,
  reverse = false,
  heading=""
}) => {

  // FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.95,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // CARD ANIMATION
  const cardVariant = {
    hidden: {
      opacity: 0,
      y: 45,
      scale: 0.97,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.08,
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <section className="why-choose-section container">

        {/* TOP ROW */}
        <div
          className={`why-choose-top ${
            reverse ? "reverse-row" : ""
          }`}
        >

          {/* LEFT */}
          <motion.div
            className="why-choose-left"
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.15,
                },
              },
            }}
          >

     <motion.h2
  className="section-heading"
  variants={fadeUp}
>
  {heading || (
    <>
      Why Choose <span>LDL Settlement Services ?</span>
    </>
  )}
</motion.h2>

            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {desc}
            </motion.p>

          </motion.div>

          {/* RIGHT */}
          <motion.div
            className="why-choose-right"
            initial={{
              opacity: 0,
              x: reverse ? -70 : 70,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
              amount: 0.25,
            }}
          >

            <motion.img
              src={image}
              alt="Why Choose LDL Settlement Services"
              whileHover={{
                scale: 1.03,
              }}
              transition={{
                duration: 0.45,
                ease: [0.22, 1, 0.36, 1],
              }}
            />

          </motion.div>

        </div>

        {/* GRID */}
        <motion.div
          className="why-choose-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.12,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.08,
              },
            },
          }}
        >

          {whyChooseData.map((item, i) => (

            <motion.div
              className="why-choose-card"
              key={i}
              custom={i}
              variants={cardVariant}
              whileHover={{
                y: -6,
              }}
              transition={{
                duration: 0.3,
              }}
            >

              <div className="card-row">

                <motion.div
                  className="why-icon-wrapper"
                  whileHover={{
                    scale: 1.08,
                    rotate: -3,
                  }}
                  transition={{
                    duration: 0.35,
                  }}
                >
                  <img
                    src={item.icon}
                    alt={`${item.title} | LDL Settlement Services`}
                  />
                </motion.div>

                <h3 className="card-heading">
                  {item.title}
                </h3>

              </div>

              <p className="section-text">
                {item.desc}
              </p>

            </motion.div>

          ))}

        </motion.div>

      </section>
    </>
  );
};

export default WhyChoose;